<template>
  <div>
    <v-card elevation="6" max-width="600">
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>{{ happname }}</v-toolbar-title></v-toolbar
      >
      <v-toolbar dense>
        <!-- <v-spacer></v-spacer> -->
        <v-btn-toggle v-model="btnGroup">
          <v-btn small rounded @click="viewchanged(1)" id="1">
            <v-icon left>mdi-text-box-outline</v-icon>
            <small>Details</small>
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <v-btn small rounded @click="viewchanged(2)" id="2" :disabled="false">
            <v-icon left>mdi-format-list-numbered</v-icon>
            <small>Pilots</small>
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <v-btn small rounded @click="viewchanged(3)" id="3" :disabled="false">
            <v-icon left>mdi-login-variant</v-icon>
            <small>Registration</small>
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
        </v-btn-toggle>
      </v-toolbar>
      <div v-if="currentView == 1">
        <HappDetails v-bind="posthapp"></HappDetails>
      </div>
      <div v-if="currentView == 2">
        <!-- List of registered pilots. Not implemented yet. -->
        <HappPilotsCard v-bind="postpilots"></HappPilotsCard>
      </div>
      <div v-if="currentView == 3">
        <div v-if="!loggedIn">
          <NeedLogin></NeedLogin>
          <div>.</div>
        </div>
        <div v-else>
          <HappSignIn v-bind="posthapp"></HappSignIn>
        </div>
      </div>

      <!-- <v-row class="d-fles align-center">
        <v-spacer></v-spacer>
        <v-checkbox v-model="loggedIn" label="LoggedIn" :disabled="true" dense></v-checkbox>
        <v-checkbox v-model="IsHappAdmin" label="Admin" :disabled="true" dense></v-checkbox>
        <v-checkbox v-model="IsHappAssistant" label="Assistant" :disabled="true" dense></v-checkbox>
        <v-spacer></v-spacer>
      </v-row> -->
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import NeedLogin from "@/components/Admin/NeedLogin.vue";
import axios from "axios";
import HappDetails from "@/components/happ/HappDetails.vue";
import HappPilotsCard from "@/components/happ/HappPilotsCard.vue";
import HappSignIn from "@/components/happ/HappSignIn.vue";

export default {
  name: "Happ",
  data() {
    return {
      startInput: 0,
      cookieToken: Number,
      cookieRegId: Number,
      regId: Number,
      ac: String,
      happ: [],
      pilots: [],
      happname: String,
      happid: Number,
      happIsSelected: false,
      showhappList: true,
      items: [],
      errors: [],
      radio: null,
      radionumber: Number,
      posthapp: {
        happ: [],
        regId: Number,
        ac: String,
      },
      postpilots: {
        items: [],
        regId: Number,
        ac: String,
      },
      postregidac: {
        regId: Number,
        ac: String,
      },
      roles: [],
      IsHappAdmin: false,
      IsHappAssistant: false,
      loggedIn: false,
      currentView: Number,
      btnGroup: 0
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.happid = this.$route.params.id;
    this.getCookies();
    this.happ = null;
    this.pilots = null;
    this.happname = "Not Selected";
    this.roles = null;
    this.getPilots(this.happid);
    this.getHapp(this.happid);
  },
  methods: {
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regId = Number(this.cookieRegId);
      this.ac = this.cookieToken;
      if (this.regId == undefined) {
        this.regId = 0;
      }
      if (this.ac == undefined) {
        this.ac = "0";
      }
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
      this.posthapp.regId = this.regId;
      this.posthapp.ac = this.ac;
    },
    viewchanged(id) {
      this.currentView = id;
    },
    radiochanged() {
      if (this.radio == "Details") {
        this.radionumber = 1;
        // this.btnGroup = 0;
      }
      if (this.radio == "Pilots") {
        this.radionumber = 2;
        // this.btnGroup = 1;
      }
      if (this.radio == "SignIn") {
        this.radionumber = 3;
        // this.btnGroup = 2;
      }
      if (this.radio == "Edit") {
        this.radionumber = 4;
        // this.btnGroup = 3;
      }
      // this.btnGroup = this.radionumber - 1
    },
    getroles(roleid) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      var uri = this.baseUrl + "getroles";
      var regId = this.regId;
      var roleId = roleid; //EventAdmin
      var toSubmit = JSON.stringify({ regId, roleId });
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.roles = response.data;
          if (this.roles[0].RoleId == 6) {
            this.IsHappAdmin = true;
          }
          if (this.roles[0].RoleId == 4) {
            this.IsHappAssistant = true;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getHapp(happid) {
      var regId = this.regId;
      var ac = this.ac;
      var happId = happid;
      var toSubmit = JSON.stringify({ happId, regId, ac });
      // console.log("gethapp", toSubmit);
      const baseUrl = this.baseUrl; // "https://pgapi.azurewebsites.net/dbapi/";
      const method = "gethapp";
      const uri = baseUrl + method;
      this.sendpost(uri, toSubmit, method);
    },
    getPilots(happid) {
      var regId = this.regId;
      var ac = this.ac;
      var happId = happid;
      var toSubmit = JSON.stringify({ happId, regId, ac });
      // console.log("gethapp", toSubmit);
      const baseUrl = this.baseUrl; //"https://pgapi.azurewebsites.net/dbapi/";
      const method = "gethapppilots";
      const uri = baseUrl + method;
      this.sendpost(uri, toSubmit, method);
    },
    sendpost(uri, toSubmit, method) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.items = response.data;
          // console.log("items", this.items);
          this.loading = false;
          this.setdataset(method);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setdataset(method) {
      if (method == "gethapp") {
        // let arr = this.items;
        // for (let i = 0; i < arr.length; i++) {
        //   if (arr[i].RegId == this.cookieRegId) {
        //     this.items[i].Enabled = this.loggedIn;
        //   }
        // }
        // this.items = arr;
        this.happ = this.items;
        this.posthapp.happ = this.happ;
        this.posthapp.regId = this.regId;
        this.posthapp.ac = this.ac;
        this.currentView = 1;
        this.happname = this.items[0].HappName;
        // console.log("posthapp",this.posthapp);
      }
      if (method == "gethapppilots") {
        // let arr = this.items;
        // for (let i = 0; i < arr.length; i++) {
        //   if (arr[i].RegId == this.cookieRegId) {
        //     this.items[i].Enabled = this.loggedIn;
        //   }
        // }
        // this.items = arr;
        this.postpilots.items = this.items;
        this.postpilots.regId = this.regId;
        this.postpilots.ac = this.ac;
        this.currentView = 2;
        // console.log("pilots",this.postpilots);
      }
      
    },
  },
  components: {
    HappDetails,
    HappPilotsCard,
    HappSignIn,
    // SelecthappForAdmin,
    NeedLogin,
    // happRoles,
    // Createhapp,
    // Deletehapp
  },
};
</script>